import SystemModal from "../Common/SystemModal";
import { useState, useEffect, useContext } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import ajaxShift from "../../util/remote/ajaxShift";
import AuthContext from "../../Context/AuthContext";
const ClosingEmployeeShift = (props) => {
  const station_id = Number(window.localStorage.getItem("FuelFy@station_id"));
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [fuels, setFuels] = useState([]);
  const [fuelReadings, setFuelReadings] = useState([]);
  const [closingTime, setClosingTime] = useState("");
  /** Fetch fuel categories */
  useEffect(() => {
    const fetchFuelCategories = async () => {
      const res = await ajaxFuelCategories.list_fuel_categories({
        station_id: station_id,
      });
      if (res.status === "OK") {
        setFuels(
          res.details.map((d) => ({
            value: d.id,
            label: d.fuel_category,
          }))
        );
        setFuelReadings(
          res.details.map((d) => ({
            fuel_id: d.id,
            meter_reading: "",
          }))
        );
      } else {
        toast.error(res.message);
      }
    };
    fetchFuelCategories();
  }, [station_id]);
  /** Handle meter reading updates */
  const handleFuelChange = (idx, value) => {
    const updated = [...fuelReadings];
    updated[idx].meter_reading = value;
    setFuelReadings(updated);
  };
  /** Convert HH:MM to full ISO datetime */
  const createISODateFromTime = (timeValue) => {
    if (!timeValue) return new Date().toISOString(); // fallback
    const [hours, minutes] = timeValue.split(":");
    const now = new Date();
    now.setHours(hours);
    now.setMinutes(minutes);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now.toISOString();
  };
  /** Submit closing shift */
  const handleSubmit = async (e, closeModal) => {
    e.preventDefault();
    if (loading) return;
    if (fuelReadings.some((fr) => !fr.meter_reading)) {
      return toast.error("Please enter all meter readings.");
    }
    const payload = {
      attendence_id: props.data.id,
      created_by: userId,
      closing_time: createISODateFromTime(closingTime),
      fuel_readings: fuelReadings.map((fr) => ({
        fuel_id: fr.fuel_id,
        closing_meter_reading: fr.meter_reading,
      })),
    };
    setLoading(true);
    const res = await ajaxShift.close_shift(payload);
    setLoading(false);
    if (res.status === "OK") {
      props.func();
      toast.success(res.message);
      setTimeout(() => closeModal(), 800);
    } else {
      toast.error(res.message);
    }
  };
  /** Modal Footer */
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleSubmit(e, controls.close)}
        disabled={loading}
      >
        {loading ? <Loader /> : "Submit Closing Readings"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Closing Attendant Shift"
      size="md"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        {fuels.map((f, idx) => (
          <div className="form-group mb-3" key={f.value}>
            <label>{f.label} Closing Meter *</label>
            <input
              type="number"
              className="form-control"
              value={fuelReadings[idx]?.meter_reading || ""}
              onChange={(e) => handleFuelChange(idx, e.target.value)}
              placeholder={`Enter meter reading for ${f.label}`}
            />
          </div>
        ))}
        <div className="form-group mb-3">
          <label>Closing Time (Optional)</label>
          <input
            type="time"
            className="form-control"
            value={closingTime}
            onChange={(e) => setClosingTime(e.target.value)}
          />
          <small className="text-danger">
            Leave empty to use the current time automatically
          </small>
        </div>
      </div>
    </SystemModal>
  );
};
export default ClosingEmployeeShift;
